import * as React from 'react';
import { cn } from '@utils';
import type { ISideNavMobileCloseProps } from './types';

/**
 * Close control for the mobile side nav drawer.
 */
export const SideNavMobileClose: React.FC<ISideNavMobileCloseProps> = ({
	onClick,
	'aria-label': ariaLabel,
	icon,
	className,
}) => {
	return (
		<button
			type="button"
			onClick={onClick}
			aria-label={ariaLabel}
			data-testid="side-nav-mobile-close"
			className={cn(
				'flex h-[3.2rem] w-[3.2rem] items-center justify-center',
				'rounded-[0.8rem] border border-white/20 bg-white/10 text-white',
				'transition-colors hover:bg-white/20',
				'focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-accent',
				className
			)}
		>
			{icon}
		</button>
	);
};

SideNavMobileClose.displayName = 'SideNavMobileClose';
